<template>
  <div class="planning-page">
    <Header></Header>
    <div class="production-info">
      <ProductionInfo
        ref="productionInfo"
        v-if="ready"
        :workCenters="productionWorkCenters"
        @productSelected="showProduct"
        @hideProduct="hideProduct"
      />
    </div>
    <div class="production-history">
      <ProductionHistory ref="productionHistory" :workCenters="workCenters" v-if="ready" />
    </div>
    <div :style="previewStyle">
      <ProductPreview ref="productPreview"></ProductPreview>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import ProductionInfo from "@/components/production-planning/ProductionInfo.vue";
import ProductionHistory from "@/components/production-planning/ProductionHistory.vue";
import ProductPreview from "@/components/user/products/ProductPreview.vue";
import WorkCenter from "@/models/WorkCenter.js";
import Helper from "@/models/Helper.js";
import User from "@/models/User.js";
export default {
  data() {
    return {
      cursorPosition: null,
      workCenters: [],
      ready: false,
      user: new User(this.$session.get("user"))
    };
  },
  computed: {
    previewStyle() {
      if (!this.cursorPosition) return;
      return {
        "z-index": 1000,
        position: "fixed",
        top: this.cursorPosition.y + 10 + "px",
        left: this.cursorPosition.x + 10 + "px",
      };
    },
  },
  async created() {
    if (this.user.company_id == 9) {
      this.$session.destroy();
      this.$router.push("/login").catch(() => {});
    }
    document.addEventListener("mousemove", this.onMouseMove, false);
    this.updateWindow();
    await this.loadCenters();
    this.ready = true;
  },
  methods: {
    async updateWindow() {
      // eslint-disable-next-line
      while (true) {
        if (this.$refs.productionInfo) {
          this.$refs.productionInfo.initialize();
        }
        if (this.$refs.productionHistory) {
          this.$refs.productionHistory.initialize();
        }
        await Helper.timeout(60000);
      }
    },
    async loadCenters() {
      this.workCenters = await WorkCenter.loadCenters(
        false,
        this.hidePreperation
      );
      this.productionWorkCenters = this.workCenters.filter((workCenter) => {
        if (workCenter.preperation) {
          return 0;
        }
        return 1;
      });
    },
    onMouseMove(e) {
      this.hideProduct();
      this.cursorPosition = {
        x: e.clientX,
        y: e.clientY,
      };
    },

    showProduct(product) {
      this.$refs.productPreview.showProduct(product);
    },

    hideProduct() {
      if (this.$refs.productPreview) {
        this.$refs.productPreview.hideProduct();
      }
    },
  },
  components: {
    Header,
    ProductionInfo,
    ProductPreview,
    ProductionHistory,
  },
};
</script>

<style scoped>
.planning-page {
  position: absolute;
  width: 100%;
  height: 100%;
}
.production-info {
  position: relative;
  height: calc(100% - 400px);
  overflow-y: auto;
  border-bottom: solid 1.6px rgb(25, 118, 210);
}
.production-info::-webkit-scrollbar {
  width: 10px;
}
.production-info::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.production-info::-webkit-scrollbar-thumb {
  background: rgba(117, 121, 129, 0.952);
}
.production-history {
  position: absolute;
  width: 100%;
  height: 330px;
  bottom: 0;
}
</style>